module.exports = __webpack_public_path__ + "img/wenzi1.3cbd163a.webp";